import client from './client';
import qs from 'qs';

/**
 * 애드익스 일자별 통계
 */
export const adexStatistics = (param) =>
  client.get(`/api/report/adex/day`, param);

/**
 * 애드익스 매체별 통계
 */
export const adexMediaStatistics = (param) =>
  client.get(`/api/report/adex/media`, param);

/**
 * 애드익스 총 일자별 통계 그래프
 */
export const adexTotDayGraph = (param) =>
  client.get(`/api/report/adex/day/totGraph`, { params: param });

/**
 * 애드익스 일자별 통계 그래프
 */
export const adexDayGraph = (param) =>
  client.get(`/api/report/adex/graph`, { params: param });

/**
 * 애드익스 수신 지면별 통계
 */
export const adexTransmitStatistics = (param) =>
  client.get(`/api/report/adex/transmit`, param);

/**
 * 애드익스 일자별 데이터 분석
 */
export const analysisDayStatistics = (param) =>
  client.get(`/api/report/adex/analysis_day`, param);
/**
 * 애드익스 일자별 데이터 분석 그래프
 */
export const analysisDayStatisticsGraph = (param) =>
  client.get(`/api/report/adex/analysis_day/graph`, { params: param });

/**
 * 애드익스 일자별 데이터 분석(모비온)
 */
export const analysisMobonStatistics = (param) =>
  client.get(`/api/report/adex/analysismobon`, param);

/**
 * 애드익스 일자별 데이터 분석(연동사)
 */
export const analysisAdExStatistics = (param) =>
  client.get(`/api/report/adex/analysisadex`, param);

/**
 * 애드익스 지면별 데이터 분석
 */
export const analysisMcStatistics = (param) =>
  client.get(`/api/report/adex/analysismc`, param);

/**
 * 애드익스 지면별 데이터 분석 ( 주간분석 )
 */
export const analysisMcWeekStatistics = (param) =>
  client.get(`/api/report/adex/analysisweek`, param);

/**
 * 애드익스 지면별 데이터 분석 ( 전일분석 )
 */
export const analysisMcDayStatistics = (param) =>
  client.get(`/api/report/adex/analysismcday`, param);

/**
 * 애드익스 지면별 데이터 분석 ( 기간분석 )
 */
export const analysisMcDateStatistics = (param) =>
  client.get(`/api/report/adex/analysis_mc_date`, param);

/**
 * 애드익스 지면별 데이터 분석 ( 테이블 )
 */
export const analysisMcTableStatistics = (param) =>
  client.get(`/api/report/adex/analysis_table`, param);

/**
 * 애드익스 연동플랫폼 리스트
 */
export const getAdexUserList = () => client.get(`/api/layout/adex/users`);

/**
 * 애드익스 외부연동매칭관리
 */
export const adexMatchingList = (param) =>
  client.get(`/api/manage/adex/matching`, param);

/**
 * 애드익스 외부연동매칭관리 - 등록
 */
export const adexMatchingAdd = (param) =>
  client.post(
    `/api/manage/adex/matching/add`,
    qs.stringify(param, {
      skipNulls: true,
      strictNullHandling: true,
      filter: function filterFunc(prefix, value) {
        for (let item in value) {
          if (value.hasOwnProperty(item)) {
            const cur = value[item];
            if (cur === '') {
              value[item] = null;
            }
          }
        }
        return value;
      },
    })
  );

/**
 * 애드익스 외부연동매칭관리 - 수정 (다중선택)
 */
export const adexMatchingModifies = (param) =>
  client.post(`/api/manage/adex/matching/modifies`, qs.stringify(param));

/**
 * 애드익스 외부연동매칭관리 - 수정
 */
export const adexMatchingModify = (param) =>
  client.post(`/api/manage/adex/matching/modify`, qs.stringify(param));

/**
 * 애드익스 외부연동매칭관리 - 삭제
 */
export const adexMatchingDelete = (seqs) =>
  client.delete(`/api/manage/adex/matching/delete`, {
    data: seqs,
  });

/**
 * 애드익스 외부연동신청내역
 */
export const adexApplyList = (param) =>
  client.get(`/api/manage/adex/apply`, param);

/**
 * 애드익스 외부연동신청내역 - 수정
 */
export const adexApplyModify = (param) =>
  client.post(`/api/manage/adex/apply/modify`, qs.stringify(param));

/**
 * 애드익스 외부연동신청내역 - 삭제
 */
export const adexApplyDelete = (externalIds, mediaScriptNos) =>
  client.delete(`/api/manage/adex/apply/delete`, {
    data: externalIds,
    mediaScriptNos,
  });

/**
 * 애드익스 외부연동신청내역 - 수정
 */
export const setAdexMemo = (param) =>
  client.post(`/api/report/adex/media/setMemo`, qs.stringify(param));

/**
 * 애드익스 히스토리
 */
export const adexHistory = (param) =>
  client.get(`/api/report/adex/media/history`, param);
